import { render, staticRenderFns } from "./BlockClients.vue?vue&type=template&id=a74562c2&"
import script from "./BlockClients.vue?vue&type=script&lang=js&"
export * from "./BlockClients.vue?vue&type=script&lang=js&"
import style0 from "./BlockClients.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports